import Vue from 'vue'
import Vuex from 'vuex'
import globalSearch from './modules/globalSearch.js'
import {
	post
} from '../utils/request.js'
import qs from 'qs'
Vue.use(Vuex)
export default new Vuex.Store({
	// 全局状态管理，可以被其他多个组件使用
	state: {
		headActive: 0,
		userInfo: JSON.parse(sessionStorage.getItem("userInfo")) || 0,
		companyInfo: JSON.parse(sessionStorage.getItem("companyInfo")) || 0,
		releaseInfo: [{
				id: '',
				first_id: '',
			},
			{
				id: '',
				first_id: '',
			},
			{
				id: '',
				first_id: '',
			},
		],
		cache_Page: [],
		notReadMsg: '',
		waitCode: ''
	},
	// 计算属性==》computed
	getters: {

	},
	// 操作state数据的=》methods
	mutations: {
		set_waitCode(state, code) {
			state.waitCode = code
		},
		get_notReadMsg(state, msg) {
			state.notReadMsg = msg
		},
		ADD_CachePage(state, page) {
			state.cache_Page = page
		},
		Del_CachePage(state, page) {
			state.cache_Page = []
		},
		SET_HeadActive(state, num) {
			state.headActive = num;
		},
		SET_UserInfo(state, info) {
			state.userInfo = info;
		},
		SET_CompanyInfo(state, info) {
			state.companyInfo = info;
		},
		set_releaseInfo(state, info) {

			if (info.id) {
				state.releaseInfo[info.index].id = info.id;
			}
			if (info.first_id !== '') {
				state.releaseInfo[info.index].first_id = info.first_id;
			}
		},
		init_releaseInfo(state, info) {
			state.releaseInfo = info;
		},
	},
	// 异步操作
	actions: {
		async getNotReadMsg(context) {
			const notread = await post('/notice/weidu_message')
			context.commit('get_notReadMsg', notread.data)
			// this.notReadMsg = notread.data
		},
	},
	modules: {
		globalSearch
	}
})